<template>
    <section class="pa-card">
        <header v-if="title || $slots.actions || $slots.header" class="pa-card__header">
            <div>
                <slot name="header">
                    <h3 class="pa-section-title">{{ title }}</h3>
                    <p v-if="description" class="pa-section-description">{{ description }}</p>
                </slot>
            </div>
            <div v-if="$slots.actions" class="d-flex align-center flex-wrap" style="gap: 8px;">
                <slot name="actions"></slot>
            </div>
        </header>
        <div :class="flush ? 'pa-card__body--flush' : 'pa-card__body'">
            <slot></slot>
        </div>
        <footer v-if="$slots.footer" class="pa-card__footer">
            <slot name="footer"></slot>
        </footer>
    </section>
</template>

<script>
// Cartao de secao: titulo + descricao + acoes no cabecalho; `flush` encosta
// tabelas nas bordas.
export default {
    name: "PaSection",
    props: {
        title: { type: String, default: null },
        description: { type: String, default: null },
        flush: { type: Boolean, default: false },
    },
};
</script>
